<template>
  <BaseViewComponent
    name="header"
    :is-preview="isPreview"
  >
    <div :class="['header-wrapper full-width flex items-center justify-between']">
      <div>
        <q-img
          v-if="headerImage"
          :src="getCompressImage(headerImage)"
          class="header-image"
        />
      </div>
      <BaseButton
        v-if="withButton"
        :label="pageData.headerButtonText"
        padding="8px 24px"
      />
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseButton from 'components/book-landing/render/BaseButton.vue';
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import getCompressImage from 'src/helpers/getCompressImage';

const props = defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
  withButton: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: null,
  },
});

const {
  headerImage,
} = useBookPageEdit(props.data);

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);
</script>

<style lang="scss" scoped>
</style>
